import { render, staticRenderFns } from "./analyticsOrderDashboard.vue?vue&type=template&id=0cf73358&"
import script from "./analyticsOrderDashboard.vue?vue&type=script&lang=js&"
export * from "./analyticsOrderDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports